import { query } from 'owa-apollo';
import type { ApolloQueryResult, TypedDocumentNode } from '@apollo/client';
import getBookingRequestOptions from './getBookingRequestOptions';
import type { BookingCustomAttributesType } from '../schema/bookingCustomAttributesType';

const bookingApolloQuery = (
    bookingQuery: TypedDocumentNode,
    options: any,
    bookingCustomAttributes?: BookingCustomAttributesType
): Promise<
    ApolloQueryResult<{
        [key: string]: any;
    }>
> => {
    const bookingOptions = getBookingRequestOptions(options, bookingCustomAttributes);
    return query(bookingQuery, bookingOptions);
};

export default bookingApolloQuery;
